// extracted by mini-css-extract-plugin
module.exports = {"TimelinePage":"TimelinePage_TimelinePage__lZ6Vc","Title":"TimelinePage_Title__22HGD"};